import styled from 'styled-components';

export const ConstructionAddressContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  column-gap: 1rem;

  & :nth-child(2) {
    min-width: 25.5rem;
  }
`;

export const ConstructionAddressItem = styled.div`
  width: 12.25rem;
  word-break: break-all;
`;
